<template>
    <div class="trophy flex relative"
        :class="[{ 'align-center flex-center-vh flex-direction-column': orientation === 'vertical' }, { 'empty': trophy.id === 0 }, { 'display-only': displayOnly }, { opaque: !finished }]">
        <template v-if="trophy.sub_category !== null && trophy.subcategory !== null">
            <trophy-hexagon :trophy="trophy" :size="size" :view="view" :displayOnly="displayOnly"
                :showTooltip="showTooltip"></trophy-hexagon>
        </template>
        <template v-else>
            <trophy-circle :trophy="trophy" :size="size" :displayOnly="displayOnly" :showTooltip="showTooltip">
            </trophy-circle>
        </template>

        <div v-if="displayOnly" class="tw-text-center">
            <p v-if="showTitle" class="tw-font-bold tw-font-bold tw-text-gray-500">{{ trophy.title }}</p>
            <p v-if="showDesc" class="tw-text-gray-500">{{ $t(trophy.description) }}</p>
        </div>

        <template v-if="!displayOnly">

            <template v-if="orientation === 'vertical'">
                <p class="normal-text bold-text" v-if="showTitle">
                    {{ trophy.title }}
                    <span class="pointstogo"
                        v-if="(trophy.threshold - trophy.user_score) > 0 && trophy.category !== 'custom'">
                        Still {{ trophy.threshold - trophy.user_score }} to go
                    </span>
                </p>
                <span class="normal-text" v-if="showDesc">
                    <template v-if="trophy.category !== 'custom'">
                        {{ $t(trophy.description) }}
                    </template>
                    <template v-else>
                        {{ trophy.description }}
                    </template>
                </span>
            </template>

            <template v-else>
                <div class="badge-info-wrapper" :style="{ width: fullWidth }">
                    <p class="normal-text bold-text" v-if="showTitle">
                        {{ trophy.title }} <span class="pointstogo"
                            v-if="(trophy.threshold - trophy.user_score) > 0 && trophy.category !== 'custom'">{{
                                    $t('trophy.still')
                            }} {{ trophy.threshold - trophy.user_score }} {{ $t('trophy.to_go')
}}</span>
                    </p>
                    <p class="normal-text desc" v-if="showDesc">
                        <template v-if="trophy.category !== 'custom'">
                            {{ $t(trophy.description) }}
                        </template>
                        <template v-else>
                            {{ trophy.description }}
                        </template>
                    </p>
                    <template v-if="showTitle">
                        <div class="badge-progress-wrapper relative" v-if="trophy.category !== 'custom'">
                            <div class="inner absolute secondary-c-bg" :style="{ width: trophy.progress + '%' }"></div>
                        </div>
                        <div class="badge-custom-earn-date" v-else>
                            <i class="far fa-check light-text"></i>
                            <p class="light-text small-text inline-block">Received on {{ trophyAchievedOn }}</p>
                        </div>
                    </template>
                </div>
            </template>

        </template>

        <i class="fa fa-times disable-trophy hover" @click="setActiveTrophy({ id: 0 })"
            v-if="activeTrophy.id === trophy.id && trophy.id !== 0 && !displayOnly"></i>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapMutations } from 'vuex';
import Global from '../../mixins/Global.js'

export default {
    name: 'Trophy',
    mixins: [Global],

    props: {
        trophy: {
            required: true,
        },
        size: {
            default: 75,
        },
        showTitle: {
            default: true,
        },
        showDesc: {
            default: true,
        },
        showTooltip: {
            default: true,
        },
        orientation: {
            default: 'horizontal'
        },
        displayOnFeed: {
            default: false,
        },
        displayOnly: {
            default: false,
        },
        view: {

        },
    },

    computed: {
        ...mapState([
            'activeTrophy',
            'trophies'
        ]),

        trophyAchievedOn() {
            return this.trophy.user !== 'undefined' ? moment(this.trophy.user.created_at).format('DD-MM-YYYY') : this.trophy.created_at;
        },

        fullWidth() {
            return 'calc(100% - ' + (this.size + 20) + 'px)';
        },
        finished() {
            if (this.view === 'unachieved') {
                return true;
            }

            if (this.displayOnFeed) {
                return true;
            }

            if (this.trophy.threshold - this.trophy.user_score == 0) {
                return true;
            }

            if (this.trophy.category == 'custom') {
                return true;
            }

        },

    },

    methods: {
        setActiveTrophy(trophy) {
            this.$store.dispatch('storeActiveTrophy', trophy);
        }
    },
}
</script>